// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../services/app-context-services";
import { getDeviceData } from "../../services/device-info-services";
import { useRouter } from "next/router";
import FetchData from "../../modules/shared/fetch-data/fetch-data";
import { API } from "../../services/api-services";

interface FetchDgIdFcmTokenProps {
  counter: number;
}

function FetchDgIdFcmToken({ counter }: FetchDgIdFcmTokenProps) {
  const [requestDgIdBody, setRequestDgIdBody] = useState<{
    fcm_token: string;
  }>();
  const router = useRouter();
  const [elapsed, setElapsed] = useState(false);
  const { dg_id, setDgId, fcm_token, syncStateTokens, setFcmToken } =
    useContext(AppContext);

  // when there were no dg_id at all, get dg_id at first
  useEffect(() => {
    if (dg_id || !elapsed || !router) return;
    //console.log("GETTING DG_ID");

    const deviceData = getDeviceData(router);
    setRequestDgIdBody(deviceData);
  }, [dg_id, router, elapsed]);

  // sets timeout for 300ms to settle every states.
  useEffect(() => {
    const timeout = setTimeout(() => setElapsed(true), 800);
    return () => clearTimeout(timeout);
  }, []);

  // useEffect(() => {

  //   if (typeof window === 'undefined') return;
  //   if (!syncStateTokens || !router?.isReady) return;
  //   if (!setFcmToken) return;
  //   const deviceData = getDeviceData(router);
  // getFcmToken(window)
  //   .then(currentToken => {
  //     console.log("fcm_token:", currentToken);

  //     if (currentToken === fcm_token) return;
  //     console.log("GETTING DG_ID FROM 2nd PART");
  //     setRequestDgIdBody({
  //       ...deviceData,
  //       fcm_token: currentToken,
  //     });
  //   })
  //   .catch(e => {
  //     console.log(e);
  //     //if(!dg_id) setRequestDgIdBody(deviceData);
  //   })

  // }, [counter]);

  return (
    <>
      {requestDgIdBody && (
        <FetchData
          url={API.request_dg_id}
          method="POST"
          body={JSON.stringify(requestDgIdBody)}
          onSuccessful={data => {
            setDgId((data as { dg_id: string }).dg_id);
            setFcmToken(requestDgIdBody.fcm_token);
          }}
          unAuthorized
          counter={counter}
        />
      )}
    </>
  );
}

export default FetchDgIdFcmToken;

// async function getFcmToken(window: Window) {

//   const firebaseConfig = {
//     apiKey: "AIzaSyCGw3Fyc6lkiIrl8eW7o7b7hxH4b20DAz4",
//     authDomain: "digitoon-web.firebaseapp.com",
//     projectId: "digitoon-web",
//     storageBucket: "digitoon-web.appspot.com",
//     messagingSenderId: "731468418485",
//     appId: "1:731468418485:web:4b474b716b849b0a969dfc"
//   };

//   const branch = process.env.NEXT_PUBLIC_APP_BRANCH;
//   console.log("branch (app): ", branch);

//   switch (branch) {
//     case "master":
//       firebaseConfig.appId = "1:731468418485:web:0625c41d3adc6483969dfc";
//       break;
//     case "beta":
//       firebaseConfig.appId = "1:731468418485:web:2d26002b10f0c8ca969dfc";
//       break;
//     case "test":
//       firebaseConfig.appId = "1:731468418485:web:3891ec32c78b6f8e969dfc";
//       break;

//     default:
//       firebaseConfig.appId = "1:731468418485:web:0625c41d3adc6483969dfc"; // master
//   }

//   console.log("firebaseConfig.appId: ", firebaseConfig.appId);

//   const vapidKey = "BEEu0K-AJuipG4xHk6F7DoLYgN6-BglqrOxeYrUKZsFzZiyGoqQMhTO9HGSjoj2AReAwtSvUEudoJW7l0XUF5zs";

//   const app = initializeApp(firebaseConfig);
//   const messaging = getMessaging(app);
//   onMessage(messaging, (payload) => {
//     console.log('Message received. ', payload);
//     const { title, ...options } = payload.notification;
//     const notif = new self.Notification(title, { ...options, dir: "rtl" });
//     notif.addEventListener("click", () => window.open(payload.data?.link || "digitoon.tv", "_blank"));
//   });

//   const permission = await Notification.requestPermission();
//   if (permission === 'granted') {
//     console.log('Notification permission granted.');
//     const serviceWorkerRegistration = await window.navigator.serviceWorker.register('/firebase-messaging-sw.js');
//     const currentToken = await getToken(messaging, {
//       serviceWorkerRegistration,
//       vapidKey,
//     });
//     if (currentToken) {
//       return currentToken;
//     } else {
//       throw new Error('No Instance ID token available. Request permission to generate one.');
//     }
//   } else {
//     throw new Error("not granted");
//   }
// }
